import type { AppStateAction } from './types';

import { AppStateActionType } from './constants';

import { analytics } from '@/analytics';

export function trackStepMiddleware(action: AppStateAction) {
  if (action.type === AppStateActionType.SET_STEP && action.value) {
    analytics.trackStep(action.value.value);
  }
}
